import { Component, Input, EventEmitter, Output, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'icos-radio-group',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => IcosRadioGroup),
    multi: true,
  }],
  template: `
    <div class="icos-radio-group" role="radiogroup">
      <ng-content></ng-content>
    </div>
  `,
})
export class IcosRadioGroup implements ControlValueAccessor {

  @Input() set disabled(val: boolean) {   // todo, is discarded.
    console.warn('icos Angular: (disabled) is discarded, use [icosDisabled] replace it.')
  }
  @Input() icosDisabled: boolean = false
  @Input('size') buttonSize: string
  @Input('fill') fillColor: string = '#20a0ff'
  @Input() textColor: string = '#ffffff'
  @Input() model: any
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>()

  subscriber: Function[] = []

  changeHandle(nextValue: string | number): void {
    setTimeout(() => {
      this.model = nextValue
      this.modelChange.emit(nextValue)
      this.controlChange(nextValue)
      this.subscriber.forEach(sub => sub())
    }, 0)
  }

  writeValue(value: any): void {
    this.model = value
    this.changeHandle(this.model)
  }

  registerOnChange(fn: Function): void {
    this.controlChange = fn
  }

  registerOnTouched(fn: Function): void {
    this.controlTouch = fn
  }

  private controlChange: Function = () => {}
  private controlTouch: Function = () => {}

}
